import zhCN from './zh-CN.json';

export const translations = {
  'zh-CN': zhCN,
  'en': {}, // fallback to original strings
};

export type Language = keyof typeof translations;